import '../../assets/css/UC/PageTitle.scss';

const PageTitle = ({ title, subtitle, icon }) => {
    return (
        <div className="title-section">
            <div className={`title-icon-and-text ${icon.type === 'svg' ? 'svg-icon' : ''}`}>
                {icon}
                <h1>{title}</h1>
            </div>
            <span className="subtitle">{subtitle}</span>
        </div>
    );
};

export default PageTitle;